export default __webpack_public_path__ + "static/media/pdg-logo-colour.6df429ad.svg";